// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"0152b335","107":"0152b335"}[chunkId] + ".chunk.css";
};